import { filterReportLinksByUserRoles } from "./filter-report-links-by-user-roles.js";
import { isReportLinkActive } from "./is-report-link-active.js";
import { mapReportLinkToSidebarMenuItem } from "./map-report-link-to-sidebar-menu-item.js";

/**
 * Mescla itens estáticos de Relatórios com report-links ativos visíveis ao usuário.
 * @param {Object[]} staticChildren
 * @param {Object[]} reportLinks
 * @param {Object[]} [userRoles]
 * @returns {Object[]}
 */
export function buildRelatoriosMenuChildren(staticChildren, reportLinks, userRoles) {
  const base = Array.isArray(staticChildren) ? staticChildren : [];
  const links = Array.isArray(reportLinks) ? reportLinks : [];

  const activeLinks = links.filter(isReportLinkActive);
  const visibleLinks = filterReportLinksByUserRoles(activeLinks, userRoles);
  const dynamicItems = visibleLinks.map(mapReportLinkToSidebarMenuItem);

  return [...base, ...dynamicItems];
}
